// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
  name: 'local',
  production: false,
  serverUrl: '',
  warningTimeoutInMins: 20,
  logoutTimeoutInMins: 22,

  local: {
    prefix: '/cebq-svc/'
  },
  devl: {
    prefix: 'https://cebq.cdxms.devl-etss.aws.fanniemae.com/cebq-svc/'
  },
  devext: {
    prefix: 'https://eboutique.cebq.sfbu.devl.intgfanniemae.com/cebq-svc/'
  },
  test: {
    prefix: 'https://cebq.cdxms.test-etss.aws.fanniemae.com/cebq-svc/'
  },
  testext: {
    prefix: 'https://eboutique.cebq.sfbu.test.intgfanniemae.com/cebq-svc/'
  },
  acpt: {
    prefix: 'https://cebq.cdxms.acpt-etss.aws.fanniemae.com/cebq-svc/'
  },
  acptext: {
    prefix: 'https://eboutique.cebq.sfbu.acpt.intgfanniemae.com/cebq-svc/'
  },
  acptvanity: {
    prefix: 'https://eboutique.acptfanniemae.com/cebq-svc/'
  },
  prod: {
    prefix: 'https://cebq.cdxms.prod-etss.aws.fanniemae.com/cebq-svc/'
  },
  prodext: {
    prefix: 'https://eboutique.cebq.sfbu.prod.fanniemae.com/cebq-svc/'
  },
  prodvanity: {
    prefix: 'https://eboutique.fanniemae.com/cebq-svc/'
  }
};
